import { Application } from "@hotwired/stimulus";
import AchAuthorizationController from "../controllers/ach_authorization_controller";
import AwardAdjustmentController from "../controllers/award_adjustment_controller";
import CartController from "../controllers/cart_controller";
import ClickableRowController from "../controllers/clickable_row_controller";
import ClipboardController from "../controllers/clipboard_controller";
import DateRangeController from "../controllers/date_range_controller";
import DisclosureController from "../controllers/disclosure_controller";
import DropdownController from "../controllers/dropdown_controller";
import FormValidationController from "../controllers/form_validation_controller";
import GivingEmbedSnippetController from "../controllers/giving_embed_snippet_controller";
import InputMaskController from "../controllers/input_mask_controller";
import LineItemController from "../controllers/line_item_controller";
import OverlayController from "../controllers/overlay_controller";
import PasswordToggleController from "../controllers/password_toggle_controller";
import RemovableController from "../controllers/removable_controller";
import ResolutionMethodController from "../controllers/resolution_method_controller";
import RowDetailsController from "../controllers/row_details_controller";
import RowLinkController from "../controllers/row_link_controller";
import SignaturePadController from "../controllers/signature_pad_controller";

const application = Application.start();
window.Stimulus = application;

application.register("ach-authorization", AchAuthorizationController);
application.register("award-adjustment", AwardAdjustmentController);
application.register("cart", CartController);
application.register("clickable-row", ClickableRowController);
application.register("clipboard", ClipboardController);
application.register("date-range", DateRangeController);
application.register("disclosure", DisclosureController);
application.register("dropdown", DropdownController);
application.register("form-validation", FormValidationController);
application.register("giving-embed-snippet", GivingEmbedSnippetController);
application.register("input-mask", InputMaskController);
application.register("line-item", LineItemController);
application.register("overlay", OverlayController);
application.register("password-toggle", PasswordToggleController);
application.register("removable", RemovableController);
application.register("resolution-method", ResolutionMethodController);
application.register("row-details", RowDetailsController);
application.register("row-link", RowLinkController);
application.register("signature-pad", SignaturePadController);
